import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { TemplateDetail } from '../types';
import templateApi from '../services/templateApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';
import { environment } from '../environments/environment';

export const BaseQueryKey = 'template';

const updateSmartlinkInRichText = async (template: TemplateDetail, companyId: number) => {
  if (!template.sections) {
    return;
  }
  for (const section of template.sections) {
    section.content = await Smartlink.QualioSmartlink.getUpdateSmartlinkTextInRichText(
      section.content,
      companyId,
      environment.QRI_SERVICE_URL,
      environment.MEDTECH_API,
    );
  }
};

export const useTemplate = (templateId: string | undefined) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  return useQuery(
    [BaseQueryKey, templateId],
    async () => {
      const template = await templateApi.getTemplateByCompanyIdAndId(companyId, templateId);

      await updateSmartlinkInRichText(template, companyId);

      return template;
    },
    {
      enabled: !!templateId,
      onError: (error) => {
        showToast({
          description: formErrorMessageForToast(t('template.hooks.fetch.error'), error),
          status: 'error',
          title: t('common.toast.error'),
          'data-cy': 'toast-fetch-template-error',
        });
      },
    },
  );
};
